import React from 'react';
import { Navbar, Nav } from 'react-bootstrap'
import ContentBar from './ContentBar'

const NavbarTop = ( ) => {
    return (
        <>
            <Navbar bg="light" expand="lg" align="center">
                <div className="sidebar-sticky"></div>
                <Navbar.Brand href="/"><img src="https://clubcapn.com/_files/200000075-b7a3cb89de/logo_bleu.png" alt="logo" width="120" className="d-inline-block align-top" /></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav" >
                    <Nav className="mr-auto">
                        <ContentBar/>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </>
    );
};

export default NavbarTop;